import { render, staticRenderFns } from "./MyMenuModal.vue?vue&type=template&id=2362a101&"
import script from "./MyMenuModal.vue?vue&type=script&lang=js&"
export * from "./MyMenuModal.vue?vue&type=script&lang=js&"
import style0 from "./MyMenuModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports